import IconProps from "./iconProps"
import { colors } from "../../constants/colors"

/**
 * เมนูเรียกคืนแผงค้า — กรอบแผงค้าพร้อมลูกศรดึงกลับเข้าองค์กร
 * ตั้งใจให้ต่างจากไอคอนคืนค่ามัดจำแผง (เอกสารตั้ง) เพราะสองเมนูนี้อยู่ติดกันใน sidebar
 */
export default function StallReclaim(props: IconProps) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5 3C3.34315 3 2 4.34315 2 6V18C2 19.6569 3.34315 21 5 21H19C20.6569 21 22 19.6569 22 18V6C22 4.34315 20.6569 3 19 3H5ZM4 6C4 5.44772 4.44772 5 5 5H19C19.5523 5 20 5.44772 20 6V7H4V6ZM4 9H20V18C20 18.5523 19.5523 19 19 19H5C4.44772 19 4 18.5523 4 18V9Z"
                fill={props.color || `${colors.themeMainColor || "currentColor"}`}
            />
            <path
                d="M16 13C16.5523 13 17 13.4477 17 14C17 14.5523 16.5523 15 16 15H10.4142L11.7071 16.2929C12.0976 16.6834 12.0976 17.3166 11.7071 17.7071C11.3166 18.0976 10.6834 18.0976 10.2929 17.7071L7.29289 14.7071C6.90237 14.3166 6.90237 13.6834 7.29289 13.2929L10.2929 10.2929C10.6834 9.90237 11.3166 9.90237 11.7071 10.2929C12.0976 10.6834 12.0976 11.3166 11.7071 11.7071L10.4142 13H16Z"
                fill={props.color || `${colors.themeMainColor || "currentColor"}`}
            />
        </svg>
    )
}
